import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the Admin Dashboard — title, a row of three stat
// cards, then two wider panels.
export default function AdminDashboardSkeleton({ isDarkMode }) {
    const card = `rounded-2xl border shadow-sm p-6 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-7xl mx-auto px-4 py-8">
                    <Skeleton width={260} height={34} className="mb-2" />
                    <Skeleton width={360} height={16} className="mb-8" />

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div key={i} className={card}>
                                <Skeleton width={44} height={44} borderRadius={12} className="mb-4" />
                                <Skeleton width={90} height={30} />
                                <Skeleton width={130} height={14} className="mt-2" />
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        {Array.from({ length: 2 }).map((_, i) => (
                            <div key={i} className={card}>
                                <Skeleton width={160} height={20} className="mb-4" />
                                <div className="space-y-3">
                                    {Array.from({ length: 5 }).map((_, r) => (
                                        <div key={r} className="flex items-center justify-between">
                                            <Skeleton width="55%" height={14} />
                                            <Skeleton width={48} height={14} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
